export const OPEN_EDIT_ADDRESS_MODAL = 'OPEN_EDIT_ADDRESS_MODAL';
export const CLOSE_EDIT_ADDRESS_MODAL = 'CLOSE_EDIT_ADDRESS_MODAL';

function openEditAddressModal(addressProps) {
  return {
    type: OPEN_EDIT_ADDRESS_MODAL,
    isEditAddressModalShown: true,
    addressProps
  };
}

function closeEditAddressModal() {
  return {
    type: CLOSE_EDIT_ADDRESS_MODAL,
    isEditAddressModalShown: false,
  };
}

export function showEditAddressModal(addressProps) {
  return dispatch => dispatch(openEditAddressModal(addressProps));
}

export function hideEditAddressModal() {
  return dispatch => dispatch(closeEditAddressModal());
}
